import createOpenApiClient from "openapi-fetch";
import { createCenterOpenApiFetch, getCenterOpenApiClientServiceRootUrl } from "@/lib/center-api";
import { SSO_API_BASE_URL } from "@/lib/env";
import type { paths } from "@airange/generated-contracts/sso-center";

export function createSsoCenterOpenApiClient(baseUrl = SSO_API_BASE_URL) {
  return createOpenApiClient<paths>({
    baseUrl: getCenterOpenApiClientServiceRootUrl(baseUrl),
    fetch: createCenterOpenApiFetch(baseUrl),
  });
}

export const ssoCenterOpenApiClient = createSsoCenterOpenApiClient();
